export const SET_LOADING = 'SET_LOADING'
export const UPDATE_EDM_USERS = 'UPDATE_EDM_USERS'
export const DELETE_EDM_USER = 'DELETE_EDM_USER'
